import * as ngCore from '@angular/core'
import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as warningPlugin from '../../../warnings/plugin'
import type { TypeParams } from '../../types'

import { Api } from './api'
import * as effects from './effects'

/** Cluster warnings plugin. */
export class Plugin extends warningPlugin.Plugin<TypeParams> {
  constructor({ collection }: Readonly<Plugin.constructor.Params>) {
    super({ api: ngCore.inject(Api), collection })

    this.feature.registerEffects(
      effects.loadForCurrentEntityOnFunctionalUsageChange(this),
      effects.loadForCurrentEntityOnOccupantsChange(this),
    )
  }
}

export namespace Plugin {
  export namespace constructor {
    export interface Params {
      readonly collection: ec.Collection<TypeParams>
    }
  }
}
